import { useEffect, useState } from 'react';
import tableeyeopenicon from '../../../assets/images/tableeyeopenicon.svg';
import tableredeyecloseicon from '../../../assets/images/tableredeyecloseicon.svg';
import { Badge, Button, Table, Form } from 'react-bootstrap';
import './cir.css';
import AddCIRModal from './Modals/AddCIRModal';
import {
    GetAllParticipantUnderMeAsync,
    GetListOfCIR
} from '../../../services/participantServices/ParticipantService';
import { useAuth } from '../../../firebase/AuthProvider';
import {
    GetCirListResDto,
    GetListOfCirReq,
    ParticipantUnderMeDto
} from '../../../interfaces/Participant';
import Pagination from '../../ui/Pagination/Pagination';
import { PaginationDto } from '../../../interfaces/Employee/Employee';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { CIRStatus } from '../../../Data/SD';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const Cir: React.FC = () => {
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const [showAddCirModal, setShowAddCirModal] = useState(false);

    // filters
    const [selectedParticipant, setSelectedParticipant] = useState<number | null>(null);
    const [selectedStatus, setSelectedStatus] = useState<CIRStatus | "">("");
    const [startDate, setStartDate] = useState<string | null>(null);
    const [endDate, setEndDate] = useState<string | null>(null);

    // pagination
    const [pagination, setPagination] = useState<PaginationDto>({
        pageNumber: 1,
        pageSize: 10
    });
    const [totalCount, setTotalCount] = useState<number>(0);

    // data
    const [participantList, setParticipantList] = useState<ParticipantUnderMeDto[]>([]);
    const [cirList, setCIRList] = useState<GetCirListResDto[]>([]);
    const [cirForView, setCIRforView] = useState<GetCirListResDto>();
    const [reload, setReload] = useState<boolean>(false);

    //others
    const [loading, setLoading] = useState<boolean>(false);

    const handleCloseAddCirModal = () => {
        setCIRforView(undefined);
        setShowAddCirModal(false);
    }
    const handleShowAddCirModal = () => {
        setShowAddCirModal(true)
    };

    useEffect(() => {
        getAllParticipantUnderMe();
    }, [currentUser]);

    useEffect(() => {
        getListOfCIR();
    }, [currentUser, selectedParticipant, selectedStatus, pagination, startDate, endDate, reload]);

    const getAllParticipantUnderMe = async () => {
        if (!currentUser) return;
        const token = await currentUser.getIdToken();
        setParticipantList([]);
        GetAllParticipantUnderMeAsync(token, currentUser.uid).then((res) => {
            if (res.success) {
                setParticipantList(res.data);
            }
        });
    };



    const getListOfCIR = async () => {
        if (!currentUser) return;
        const token = await currentUser.getIdToken();

        const payload: GetListOfCirReq = {
            participantId: selectedParticipant,
            startDate: startDate ? moment(startDate).toISOString() : null,
            endDate: endDate ? moment(endDate).toISOString() : null,
            userId: currentUser.uid,
            pageNumber: pagination.pageNumber,
            pageSize: pagination.pageSize,
            status: selectedStatus
        };

        setCIRList([]);
        setTotalCount(0);

        setLoading(true);
        GetListOfCIR(token, payload).then((res) => {
            if (res.success) {
                setTotalCount(res.data.totalCount);
                setCIRList(res.data.items);
            }
        }).finally(() => {
            setLoading(false);
        })
    };

    const onPageChange = (pageNum: number) => {
        setPagination((prev) => ({
            ...prev,
            pageNumber: pageNum
        }));
        getListOfCIR();
    };

    const resetPageSize = (pageNumber: number, pageSize: number) => {
        setPagination({ pageNumber, pageSize });
    };

    function redirectToTask(taskId: number | null) {
        if (!taskId) return;
        navigate(`/task/SSA-${taskId}`);
    }


    return (
        <>
            <div className="common_card">
                <div className="top border_tittle top_bar_flx cir_top">
                    <div className="top_bar_tittle">
                        <h2>Critical Incident Reports</h2>
                    </div>
                    <Button
                        variant="primary"
                        className="btn_sm"
                        onClick={() => {
                            setCIRforView(undefined);
                            handleShowAddCirModal()
                        }}
                    >
                        Add Critical Incident
                    </Button>
                </div>

                {/* Filters */}
                <div className="cir_fillter flex-wrap">
                    <div className="cir_fillter_filled flex-wrap">
                        <Form.Group
                            className="custom_input_flled mb-0"
                            controlId="participantSelect"
                        >
                            <Form.Label>Filter by Participants</Form.Label>
                            <Form.Select
                                aria-label="Select participant"
                                className="sm_input"
                                value={selectedParticipant ?? ''}
                                onChange={(e) =>
                                    setSelectedParticipant(
                                        e.target.value ? Number(e.target.value) : null
                                    )
                                }
                            >
                                <option value="">All</option>
                                {participantList.map((p) => (
                                    <option key={p.id} value={p.id}>
                                        {p.firstName} {p.lastName}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="custom_input_flled mb-0"
                            controlId="participantSelect">
                            <Form.Label>Status</Form.Label>
                            <Form.Select
                                name="status"
                                aria-label="Select participant"
                                className="sm_input"
                                value={selectedStatus}
                                onChange={(e) => {
                                    setSelectedStatus(e.target.value as CIRStatus);
                                }}
                            >
                                <option value="">All</option>
                                {Object.values(CIRStatus).map((status) => (
                                    <option key={status} value={status}>
                                        {status.charAt(0) + status.slice(1).toLowerCase()}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group
                            className="custom_input_flled mb-0"
                            controlId="startDate"
                        >
                            <Form.Label>From</Form.Label>
                            <Form.Control
                                type="date"
                                className="sm_input"
                                value={startDate ?? ''}
                                onChange={(e) => setStartDate(e.target.value || null)}
                                max={new Date().toISOString().split("T")[0]}
                            />
                        </Form.Group>

                        <Form.Group
                            className="custom_input_flled mb-0"
                            controlId="endDate"
                        >
                            <Form.Label>To</Form.Label>
                            <Form.Control
                                type="date"
                                className="sm_input"
                                value={endDate ?? ''}
                                onChange={(e) => setEndDate(e.target.value || null)}
                                max={new Date().toISOString().split("T")[0]}
                            />
                        </Form.Group>
                    </div>
                    <div className="cir_fillter_btn">
                        <Button
                            variant="primary"
                            className="btn_sm"
                            onClick={getListOfCIR}
                        >
                            Search
                        </Button>
                    </div>
                </div>

                {/* Table */}
                <Table responsive className="common_table">
                    <thead>
                        <tr>
                            <th>Participant</th>
                            <th>Incident Type</th>
                            <th>Task Id</th>
                            <th>Date Incident Occurred</th>
                            <th>Date CIR Logged</th>
                            <th>Status</th>
                            <th className="action_th">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            loading ?
                                (<tr>
                                    <td colSpan={6} className="text-center">
                                        Loading...
                                    </td>
                                </tr>)
                                :
                                cirList.length > 0 ? (
                                    cirList.map((c, index) => (
                                        <tr key={index}>
                                            <td>{c.participantName}</td>
                                            <td>{c.incidentType}</td>
                                            <td onClick={() => {
                                                if (c.taskId) {
                                                    redirectToTask(Number(c.taskId))
                                                }
                                            }}>{c.taskId}</td>
                                            <td>{moment(c.incidentDate).format('MM/DD/YYYY')}</td>
                                            <td>{moment(c.createdAt).format('MM/DD/YYYY')}</td>
                                            <td>
                                                <Badge bg="warning">{c.status}</Badge>
                                            </td>
                                            <td className="action_btn">

                                                {/* VIEW */}
                                                <span className="mx-2">
                                                    <FontAwesomeIcon
                                                        icon={faEye}
                                                        className="text-primary cursor-pointer"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setCIRforView(c);
                                                            handleShowAddCirModal();
                                                        }}
                                                    />
                                                </span>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={6} className="text-center">
                                            No records found
                                        </td>
                                    </tr>
                                )}
                    </tbody>
                </Table>

                <Pagination
                    currentPage={pagination.pageNumber}
                    totalPages={Math.ceil(totalCount / pagination.pageSize)}
                    onPageChange={onPageChange}
                    pageSize={pagination.pageSize}
                    resetPageSize={resetPageSize}
                />
            </div>

            {showAddCirModal && (
                <AddCIRModal
                    hanleCloseShowCIRModal={handleCloseAddCirModal}
                    showAddCirModal={showAddCirModal}
                    participantList={participantList}
                    viewCIR={cirForView}
                    refreshList={() => setReload(!reload)}
                />
            )}
        </>
    );
};

export default Cir;
